import { getConfigTenant, isCaponeTenant } from "@capone/common";
import { useMemo } from "react";
import { PolicyTier } from "redmond";
import { getIsDefaultPolicySelected } from "../utils/getIsDefaultPolicySelected"

export const useShowPolicyBanner = (policies?: PolicyTier) => {
  if (isCaponeTenant(getConfigTenant())) return false;

  return useMemo(() => !getIsDefaultPolicySelected(policies), [policies]);
};
